const flag = (import.meta.env.VITE_TGAPP_ENABLE_TELEGRAM_MOCK ?? 'auto').toString()

const useTelegramMock =
  flag === 'true' || (flag !== 'false' && import.meta.env.DEV)

export const appConfig = {
  useTelegramMock,
  mockInitData: 'telegram-dev-mock',
  mockTelegramUser: {
    id: Number(import.meta.env.VITE_TGAPP_MOCK_USER_ID ?? '1111111'),
    username: import.meta.env.VITE_TGAPP_MOCK_USERNAME ?? 'dev_user',
    first_name:
      import.meta.env.VITE_TGAPP_MOCK_USER_FIRST_NAME ??
      'Dev'
  }
} as const

export type AppConfig = typeof appConfig
